import { Tag } from 'antd';

const STATUS_MAP = {
    0: { label: 'Invalid', color: 'default' },
    1: { label: 'Pending', color: 'orange' },
    2: { label: 'Confirmed', color: 'blue' },
    3: { label: 'Ongoing', color: 'geekblue' },
    4: { label: 'Pending Settlement', color: 'gold' },
    5: { label: 'Completed', color: 'green' },
    6: { label: 'Cancelled', color: 'red' },
    7: { label: 'Action Needed', color: 'purple' },
};

/**
 * @param {object} props
 * @param {number} props.status - The booking status code.
 * @param {object} props.style - The style of the tag.
 */
function BookingTagStatus({ status, style }) {
    const { label, color } = STATUS_MAP[status] || {
        label: 'Unknown',
        color: 'default',
    };

    return (
        <Tag color={color} style={style}>
            {label}
        </Tag>
    );
}

export default BookingTagStatus;
